// extracted by mini-css-extract-plugin
export default {"container":"SwitchTabBar_container__NCE3I","button":"SwitchTabBar_button__+pvcP","active":"SwitchTabBar_active__2no4h"};